<template>
  <y-wrapper @back="goBack">
    <template slot="nav">
      <div class="navWrap">
        <div class="navTitle">
          <p>
            <span v-if="planInfo && planInfo.plan_name">{{
              planInfo.plan_name
            }}</span>
          </p>
        </div>
      </div>
    </template>

    <template slot="main">
      <div class="dMain">
        <div class="sign-info" v-if="!pageLoading && planInfo">
          <vue-scroll :ops="vuescrollOpt">
            <div class="scroll-content">
              <div class="yioks-flex-box">
                <div class="yioks-flex-item half">
                  <div class="yioks-card">
                    <div class="yioks-card-title">招标信息</div>
                    <div class="yioks-card-content">
                      <p class="info-line">
                        <span>级别：</span>{{ planInfo.plan_level }}级
                      </p>
                      <p class="info-line">
                        <span>类型：</span
                        >{{ planInfo.plan_type | heightClassPlane }}
                      </p>
                      <p class="info-line">
                        <span>截止时间：</span
                        >{{ planInfo.end_date | time(false) }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="yioks-flex-item half">
                  <div class="yioks-card">
                    <div class="yioks-card-title">协调员相关信息</div>
                    <div class="yioks-card-content">
                      <div
                        class="info-line border-line"
                        v-for="(item, index) in linkmenData"
                        :key="index"
                      >
                        <div class="yioks-flex-box wrap">
                          <div class="yioks-flex-item half">
                            <span>姓名：</span>{{ item.name }}
                          </div>
                          <div class="yioks-flex-item half">
                            <span>联系方式：</span
                            ><span :title="item.mobile_phone">{{
                              item.mobile_phone
                            }}</span>
                          </div>
                          <div class="yioks-flex-item half over">
                            <span>邮箱：</span
                            ><span :title="item.email">{{ item.email }}</span>
                          </div>
                          <div class="yioks-flex-item half over">
                            <span>工作单位：</span
                            ><span :title="item.work">{{
                              item.work || "--"
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="yioks-flex-box">
                <div class="yioks-flex-item">
                  <div class="yioks-card">
                    <div class="yioks-card-title">说明及附件</div>
                    <div class="yioks-card-content">
                      <div class="info-line flex">
                        <div style="width: 60px">说明：</div>
                        <div v-html="planInfo.content"></div>
                      </div>
                      <div class="info-line flex">
                        <div style="width: 60px">附件：</div>
                        <div class="left">
                          <a
                            v-for="(item, index) in documentDate"
                            :key="index"
                            :href="item.document_address"
                            target="_blank"
                            ><span class="link_name">{{
                              item.document_title
                            }}</span></a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <template v-if="isView">
                <div
                  class="sign-btns"
                  v-if="venueInfoList && venueInfoList.length"
                >
                  <div
                    class="line-info flex btns"
                    v-for="(item, index) in venueInfoList"
                    :key="index"
                  >
                    <div class="btn-name" v-if="planInfo.time_change_way === 'month'">
                      培训班月份选择{{ index + 1 }}&nbsp;&nbsp;{{
                        item.the_tender_phase
                      }}
                    </div>
                    <div class="btn-name" v-else>
                      培训班期数选择{{ index + 1 }}&nbsp;&nbsp;{{
                        item.the_tender_phase
                      }}
                    </div>
                    <div class="btn-right">
                      <el-button
                        v-if="item.venue_info_uuid"
                        type="primary"
                        @click="handleViewInViewModel(item)"
                        size="small"
                        >查看</el-button
                      >
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="sign-btns" v-if="classPhaseCheckboxList.length">
                  <div
                    class="line-info flex btns"
                    v-for="(item, index) in classPhaseCheckboxList"
                    :key="index"
                  >
                    <div class="btn-name" v-if="planInfo.time_change_way === 'month'">
                      培训班月份选择{{ index + 1 }}&nbsp;&nbsp;{{
                        item.label
                      }}
                    </div>
                    <div class="btn-name" v-else>
                      培训班期数选择{{ index + 1 }}&nbsp;&nbsp;{{
                        item.label
                      }}
                    </div>
                    <div class="btn-right">
                      <el-button
                        v-if="!isTimeBeforeToday"
                        type="primary"
                        @click="handleBtnClick(item)"
                        size="small"
                        >{{
                          item.meta.venue_info_uuid ? "编辑" : "参与投标"
                        }}</el-button
                      ><el-button
                        v-if="item.meta.venue_info_uuid"
                        type="primary"
                        @click="handleView(item)"
                        size="small"
                        >查看</el-button
                      ><el-button
                        v-if="item.meta.venue_info_uuid && !isTimeBeforeToday"
                        type="danger"
                        @click="handleDeletSign(item)"
                        size="small"
                        >删除</el-button
                      >
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </vue-scroll>
        </div>
        <div class="btns-box" v-if="!isView">
          <template v-if="recordInfo && recordInfo.record_status !== 'submit'">
            <el-button
              v-if="venueInfoList.length"
              type="primary"
              @click="handleChangeSignStatus('submit')"
              >提交投标信息</el-button
            >
            <el-button v-else disabled type="info">提交投标信息</el-button>
          </template>

          <el-button
            v-if="recordInfo && recordInfo.record_status == 'submit'"
            type="danger"
            @click="handleChangeSignStatus('back')"
            >撤销投标信息</el-button
          >
        </div>
      </div>
      <!-- 删除确认 -->
      <y-tips
        :showTips="isDeleteConfirm"
        :tips="'确认删除此投标信息吗？'"
        @hideTips="handleConfirmDelte"
      ></y-tips>
      <!-- 状态修改提示 -->
      <y-tips
        :showTips="isShowActionTips"
        :tips="
          actionStatus == 'submit'
            ? '确认提交投标信息吗？'
            : '确认撤销投标信息吗？'
        "
        @hideTips="handleConfirmDoAction"
      ></y-tips>

      <template v-if="isShowViewSign">
        <sign-plane-info
          :isShowDialog.sync="isShowViewSign"
          :venueInfoUuid="venueInfoUuid"
          :timePhase="timePhase"
        ></sign-plane-info>
      </template>

      <template v-if="isShowSignDialog">
        <el-dialog title="" :visible.sync="isShowSignDialog" width="550px">
          <div class="form-box" v-if="selectForAddressModel.length">
            <el-form
              :model="signForm"
              ref="signFormDom"
              :rules="signFormRules"
              label-width="120px"
            >
              <el-form-item label="请选择举办地" prop="address_model">
                <el-select
                  v-model="signForm.address_model"
                  placeholder="请选择举办地"
                >
                  <el-option
                    v-for="item in selectForAddressModel"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div class="little-tips">
              如果不存在您需要的举办地点，可以<span
                class="suc"
                @click="goToAddSignAddress"
                >点击此处，前往添加举办地。</span
              >
            </div>
          </div>
          <div class="tips-box" v-else>
            当前没有可用举办地信息，<span
              class="suc"
              @click="goToAddSignAddress"
              >点击此处，前往添加举办地。</span
            >
          </div>

          <div class="footer">
            <el-button type="primary" @click="handleSignComplete"
              >确 定</el-button
            >
            <el-button type="danger" @click="isShowSignDialog = false"
              >取 消</el-button
            >
          </div>
        </el-dialog>
      </template>
    </template>
  </y-wrapper>
</template>

<script>
import {
  viewHeighClassPlane,
  deleteSignPlan,
  toggleSignStatus,
  planeTemplateListAll,
} from "@/api/system_manager/api";
import ops from "@/assets/js/vuescrollOption";
import createScrollOpt from "@/assets/js/vuescrollOption";
import { heightClassPlane } from "@/assets/js/yioksFilters";
import { requiredItem } from "@/assets/js/formRules";
import moment from "moment";
import { isTimeBefore } from "@/assets/js/utils";

export default {
  data() {
    return {
      ops: ops(),
      classPhase: [],
      classPhaseCheckboxList: [],
      documentDate: [],
      linkmenData: [],
      planInfo: null,
      pageLoading: false,
      vuescrollOpt: createScrollOpt(),
      recordInfo: null, //
      venueInfoList: [], //
      userChoose: [],
      isDeleteConfirm: false,
      deleteRow: null,
      isShowViewSign: false,
      venueInfoUuid: null,
      isShowActionTips: false,
      actionStatus: null,
      selectForAddressModel: [],
      addressList: [],
      isShowSignDialog: false,
      signForm: {
        address_model: "",
      },
      signFormRules: {
        address_model: requiredItem("举办地", true),
      },
      signRow: null,
      timePhase: "",
    };
  },

  filters: {
    heightClassPlane,
  },

  components: {
    "yioks-page-nav": () => import("@/components/PageNav/PageNav"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
    "v-icon": () => import("vue-awesome/components/Icon"),
    "yioks-tips": () => import("@/components/Tips/Dialog"),
    "yioks-empty": () => import("@/components/Tips/Empty"),
    "sign-plane-info": () =>
      import("@/components/HeightClassPlan/ViewPlaneInfo"),
  },

  computed: {
    uuid() {
      const { plan_uuid } = this.$route.query;
      return plan_uuid;
    },
    isView() {
      const { isView } = this.$route.query;
      return isView == "1" ? true : false;
    },

    isTimeBeforeToday() {
      const { end_date } = this.planInfo;
      const dayTime = new Date().getTime();
      return isTimeBefore(end_date, dayTime, "day");
    },
  },

  async created() {
    await this.loadModelList(); // 确保先获取投标信息
    this.getPageInfo();
  },
  methods: {
    goBack() {
      this.$router.push({
        path: "heigh_class_list",
      });
    },
    async loadModelList() {
      try {
        const { data } = await planeTemplateListAll();
        if (data.status !== 0) {
          this.$message.error(data.msg);
          return;
        }
        const { venueListAll } = data.result;
        this.addressList = venueListAll;
        this.selectForAddressModel = venueListAll.map((item) => {
          const { undertake_unit, venue_uuid } = item;
          return {
            label: undertake_unit,
            value: venue_uuid,
          };
        });
      } catch (err) {
        console.error("err", err);
      }
    },

    goToAddSignAddress() {
      const backUrl = JSON.stringify(this.$route.fullPath);
      this.$router.push({
        path: "add_model",
        query: {
          backUrl: backUrl,
        },
      });
    },

    // 获取page信息
    getPageInfo() {
      this.pageLoading = true;
      viewHeighClassPlane(this.uuid)
        .then(({ data }) => {
          this.pageLoading = false;
          if (data.status !== 0) {
            this.$message.error(data.msg);
            return;
          }
          const {
            classPhase,
            documentDate,
            linkmenData,
            planInfo,
            recordInfo,
            venueInfoList,
          } = data.result;
          // 避免哪个数据出现异常为空
          classPhase && (this.classPhase = classPhase);
          documentDate && (this.documentDate = documentDate);
          linkmenData && (this.linkmenData = linkmenData);
          recordInfo && (this.recordInfo = recordInfo);
          if (venueInfoList && venueInfoList.length) {
            this.venueInfoList = venueInfoList;
          } else {
            this.venueInfoList = [];
          }
          planInfo && (this.planInfo = planInfo);
          if (classPhase.length) {
            const moment = require("moment");
            this.classPhaseCheckboxList = classPhase.map((item) => {
              const { start_date, end_date, plan_id, phase_id,start_date_two,end_date_two } = item;
              let start_date_str = moment(start_date).format("yyyy-MM");
              let end_date_str = moment(end_date).format("yyyy-MM");
              let label = `${start_date_str} 至 ${end_date_str}`;
              if(this.planInfo.time_change_way === 'periods'){
                start_date_str = moment(start_date).format("yyyy-MM-DD") + '至' + moment(end_date).format("yyyy-MM-DD");
                end_date_str = moment(start_date_two).format("yyyy-MM-DD") + '至' + moment(end_date_two).format("yyyy-MM-DD");
                label = '阶段一：'+`${start_date_str}，阶段二：${end_date_str}`;
              }
              const ifSignedInfo = venueInfoList.find((item) => {
                return item.the_tender_phase == label;
              });
              let obj = {};
              if (ifSignedInfo) {
                const { venue_info_id, venue_info_uuid, record_id } =
                  ifSignedInfo;
                obj = { venue_info_id, record_id, venue_info_uuid };
              }
              let callbackObj = {
                label: label,
                meta: {
                  ...item,
                  ...obj,
                  start_date_str: start_date_str,
                  end_date_str: end_date_str,
                },
              };

              return callbackObj;
            });
          }
        })
        .catch((err) => {
          this.pageLoading = false;
          console.error("err", err);
        });
    },

    handleSignComplete() {
      // console.log('this.signForm', this.signForm)
      // console.log('this.signRow', this.signRow)
      this.$refs.signFormDom.validate((valid) => {
        if (valid) {
          const { address_model } = this.signForm;
          const { start_date_str, end_date_str, venue_info_uuid } =
            this.signRow;
          const { plan_id, record_uuid } = this.recordInfo;

          this.$router.push({
            path: "sign_plane_complete",
            query: {
              plan_id: plan_id,
              plan_uuid: this.uuid,
              record_uuid: record_uuid,
              start_date_str: start_date_str,
              end_date_str: end_date_str,
              time_change_way: this.planInfo.time_change_way,
              venue_info_uuid: venue_info_uuid,
              address_model: address_model,
            },
          });
        }
      });
    },
    // 投标
    handleBtnClick(row) {
      this.signRow = row.meta;
      const { start_date_str, end_date_str, venue_info_uuid } = row.meta;
      if (venue_info_uuid) {
        const { address_model } = this.signForm;
        const { start_date_str, end_date_str, venue_info_uuid } = this.signRow;
        const { plan_id, record_uuid } = this.recordInfo;

        this.$router.push({
          path: "sign_plane_complete",
          query: {
            plan_id: plan_id,
            plan_uuid: this.uuid,
            record_uuid: record_uuid,
            start_date_str: start_date_str,
            end_date_str: end_date_str,
            venue_info_uuid: venue_info_uuid,
            time_change_way: this.planInfo.time_change_way,
            address_model: address_model,
          },
        });
      } else {
        this.isShowSignDialog = true;
      }
    },
    handleView(row) {
      const {
        meta: { venue_info_uuid, phase,phase_two },
      } = row;
      if (venue_info_uuid) {
        this.venueInfoUuid = venue_info_uuid;
        let phase_ = phase;
        if(this.planInfo.time_change_way === 'periods'){
          phase_ = '阶段一：'+phase+'，阶段二： '+phase_two;
        }
        this.timePhase = phase_;
        this.isShowViewSign = true;
      } else {
        console.error("【错误冗余】");
      }
    },
    handleViewInViewModel(row) {
      const { venue_info_uuid, the_tender_phase } = row;
      if (venue_info_uuid) {
        this.venueInfoUuid = venue_info_uuid;
        this.timePhase = the_tender_phase;
        this.isShowViewSign = true;
      } else {
        console.error("【错误冗余】");
      }
    },

    handleDeletSign(row) {
      this.isDeleteConfirm = true;
      this.deleteRow = row;
    },

    // 确认删除
    handleConfirmDelte(val, sure) {
      if (sure) {
        const {
          meta: { venue_info_uuid },
        } = this.deleteRow;
        deleteSignPlan(venue_info_uuid)
          .then(({ data }) => {
            if (data.status !== 0) {
              this.$message.error(data.msg);
              return;
            }
            this.$message.success("操作成功！");
            this.isDeleteConfirm = false;
            this.deleteRow = null;
            this.getPageInfo(); // 刷新页面数据
          })
          .catch((err) => {
            this.isDeleteConfirm = false;
            this.deleteRow = null;
            console.error("err", err);
          });
      }
      this.isDeleteConfirm = val;
    },

    // 提交/撤销报告状态
    handleChangeSignStatus(status) {
      this.actionStatus = status;
      this.isShowActionTips = true;
    },

    // 投标状态修改
    handleConfirmDoAction(val, sure) {
      if (sure) {
        const queryData = {
          plan_uuid: this.uuid,
          type: this.actionStatus,
        };
        toggleSignStatus(queryData)
          .then(({ data }) => {
            this.isShowActionTips = false;
            if (data.status !== 0) {
              this.$message.error(data.msg);
              return;
            }
            this.$message.success("操作成功！");
            this.$router.replace({
              path: this.$route.path,
              query: {
                ...this.$route.query,
                isView: 1,
              },
            });
            this.getPageInfo();
          })
          .catch((err) => {
            console.error("err", err);
          });
      } else {
        this.isShowActionTips = val;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
@import '~@/assets/css/defaultPage'
.sign-info
  padding 20px 5px 20px 10px !important
.info-line
  line-height 35px
.over
  over_hide()
.border-line
  border-bottom 1px solid #fff
.link_name
  color $color_suc !important
.left
  display flex
  flex-direction column
.sign-btns
  padding 10px 20px
  display flex
  flex-direction column
  // justify-content: flex-start
  // flex-wrap: wrap
.btns
  align-items center
  margin-bottom 20px
  &:last-child
    margin-bottom 0px
  .btn-name
    margin-right 10px
    font-size $font_size_medium
.dMain
  background none
  .sign-info
    height 540px
    background-color $block_bg_color_base
    padding 20px 10px 0px
    .scroll-content
      margin 0 5px 0 0
  .btns-box
    display flex
    width 35%
    margin 20px auto 0
    display flex
    justify-content space-around
.footer
  display flex
  width 35%
  margin 20px auto 0
  display flex
  justify-content space-around
.suc
  color $color_suc
  cursor pointer
.little-tips
  padding 20px 30px
  text-align right
.tips-box
  height 100px
  display flex
  align-items center
  justify-content center
  font-size 18px
.el-button--small
  padding: 9px 10px;
</style>
